module.exports = __webpack_public_path__ + "media/images/dmc/logo-tj-travel-4076e3747ac6bf124e3678ce1d60df09.png";